<template>
    <div>
        <Licenses class="licenses-page padding" :highlight="config.license"></Licenses>
    </div>
</template>

<script>
    import Licenses from './../licenses/licenses.vue'
    import Page from './../../mixins/page.vue'

    export default {
        mixins: [Page],
        components: {
            Licenses
        }
    }

</script>